(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/authenticate/assets/javascripts/login-api.js') >= 0) return;  svs.modules.push('/components/accountservices/authenticate/assets/javascripts/login-api.js');

'use strict';

const authenticateSingleton = new svs.core.Events(new svs.accountservices.authenticate.Authenticate());
svs.accountservices.authenticate.login = {
  on() {
    authenticateSingleton.listenTo(...arguments);
  },
  off() {
    authenticateSingleton.stopListeningTo(...arguments);
  },
  start(options) {
    authenticateSingleton.start(options);
  },
  poll(options) {
    authenticateSingleton.poll(options);
  },
  pause() {
    authenticateSingleton.pause();
  },
  resumePendingLogin() {
    let isIam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    authenticateSingleton.resumePending(isIam, options);
  },
  resume() {
    authenticateSingleton.resume();
  },
  cancel() {
    authenticateSingleton.cancel();
  },
  getAppUrl() {
    let isIam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return authenticateSingleton.getAppUrl(isIam);
  },
  isStarted() {
    return authenticateSingleton.isStarted();
  },
  startedWithSsn() {
    return authenticateSingleton.startedWithSsn();
  },
  unitTestResetState() {
    authenticateSingleton.resetState();
  }
};
svs.accountservices.authenticate.sign = {
  on() {
    authenticateSingleton.listenTo(...arguments);
  },
  off() {
    authenticateSingleton.stopListeningTo(...arguments);
  },
  start(options) {
    authenticateSingleton.sign(options);
  },
  poll(options) {
    authenticateSingleton.poll(options);
  },
  pause() {
    authenticateSingleton.pause();
  },
  resumePending() {
    authenticateSingleton.resumePending();
  },
  resume() {
    authenticateSingleton.resume();
  },
  cancel() {
    authenticateSingleton.cancel();
  },
  getAppUrl() {
    return authenticateSingleton.getAppUrl();
  },
  isStarted() {
    return authenticateSingleton.isStarted();
  },
  startedWithSsn() {
    return authenticateSingleton.startedWithSsn();
  },
  unitTestResetState() {
    authenticateSingleton.resetState();
  }
};

 })(window);